import { render, staticRenderFns } from "./Contratar.vue?vue&type=template&id=38c677e1&scoped=true&"
import script from "./Contratar.vue?vue&type=script&lang=js&"
export * from "./Contratar.vue?vue&type=script&lang=js&"
import style0 from "./Contratar.vue?vue&type=style&index=0&id=38c677e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38c677e1",
  null
  
)

export default component.exports